import React from 'react';
const coverage = [{
  label: 'Calendar',
  body: '365 days mapped across 4 seasonal pillars'
}, {
  label: 'Formats',
  body: 'EMOM, AMRAP, Tabata, partner and team finishers'
}, {
  label: 'Equipment',
  body: 'Kettlebells, dumbbells, bands — or zero equipment'
}, {
  label: 'Groups',
  body: 'Mixed levels, small studios, 30+ people solo'
}, {
  label: 'Coaching',
  body: 'Cueing system, transition talk, voice preservation'
}, {
  label: 'Business',
  body: 'Attendance, referrals, re-activation, content calendar'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-184" data-mp="28cgecpd84yae">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-185" data-mp="2icqryb3687q3">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-186" data-mp="2iamfh4r7i0e7">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-187" data-mp="1po1ow6ik1sbp">
          The 0-Decision Framework™
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-188" data-mp="1f2j5kvv5z3pa">
          2,500 workouts are 2,500 decisions. A library doesn&apos;t remove the
          work — it moves it: you still open, search, pick, sequence and adapt,
          every single week. Bootcamp Ready makes the decision once, in
          advance, and ties it to a date. You open the day&apos;s session and
          coach it.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-189" data-mp="w2wvmd60m7jd">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-white/5 px-4 py-3" data-id="element-190" data-mp="11203e5ddqrv1">
              <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-191" data-mp="2chx2gmexms5z">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-192" data-mp="2hfyguu1ey3b4">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}